import React, { FC } from "react";
import classNames from "classnames/dedupe";
import { ILink, Link } from "../../ActionsSelectors/Link";
import { IImageData, Image } from "../../Utility/MediaBuilder/Image";

export interface IMenuBannerProps {
  title: string;
  description: string;
  customImage?: JSX.Element;
  image: IImageData | null;
  link: ILink;
  /**
   * The custom set of css classes used to style component
   */
  classes?: {
    /**
     * applied to outer 'div' element
     */
    root?: string;
  };
}

const MenuBanner: FC<IMenuBannerProps> = ({
  title,
  description,
  customImage,
  image = {},
  link,
  classes,
}) => (
  <div className={classNames("flyout-menu__banners", classes?.root)}>
    <Link classes={{ root: "banner banner--nav" }} {...link}>
      <>
        <div className="banner__img">
          <div>{customImage ?? <Image {...image} />}</div>
        </div>

        <div className="banner__title">{title}</div>

        <div className="banner__desc">{description}</div>
      </>
    </Link>
  </div>
);

export default MenuBanner;
